import { Button, Dialog, Popover } from 'react-aria-components';
import styled from 'styled-components';
import { CloseButton } from '@/components/CloseButton';
import { sharedLinkStyles } from '@/components/Link/Link.styled';

export const ModalTrigger = styled(Button)`
  background: transparent;
  border: 0;
  ${sharedLinkStyles}
  font-size: var(--font-size-text-xl);
  line-height: 30px;
  color: var(--grey-500);

  &:is(.product__primary__details__row__detail &) {
    white-space: nowrap;
    font-size: var(--font-size-text-md);

    @media (width >= 48rem) {
      font-size: var(--font-size-text-xl);
    }

  &:is([data-selected] &) {
    color: var(--grey-700);
  }

  #deliveryAddress ~ & {
    font-size: var(--font-size-text-md);
    color: var(--brand-900);
  }
`;

export const Overlay = styled(Popover)`
  display: flex;
  width: 100vw;
  max-width: 382px;
  height: fit-content;
  padding: 20px 16px 16px;
  background: var(--grey-100);
  border: 1px solid var(--black);
  border-radius: var(--radius-xlarge);
  box-shadow: var(--shadow-overlay);
  position: relative;

  @media (width <= 24rem) {
    left: 0 !important;
  }
`;

export const OverlayContent = styled(Dialog)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  overflow-y: auto;
  padding: var(--spacing-large) calc(var(--spacing-large) * 2) var(--spacing-large) var(--spacing-large);
  background: var(--white);

  &:focus-visible {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }
`;

export const CloseXButton = styled(CloseButton)`
  position: absolute;
  top: 32px;
  right: 24px;

  & svg {
    display: flex;
  }
`;
